import { render } from "./ListCodexComponent.vue?vue&type=template&id=6c0c6388"
import script from "./ListCodexComponent.vue?vue&type=script&lang=js"
export * from "./ListCodexComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__